var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHalfStarActive = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m50 0 11.8 35.4h36.6L68.6 57.3l11.7 35.4-30.3-20-30.3 20 11.7-35.4L1.6 35.4h36.6Z",
  fill: "url(#half-star-active_svg__a)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "half-star-active_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  style: {
    stopColor: "#87888b"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  style: {
    stopColor: "#e2e2e4"
  }
}))));
export default SvgHalfStarActive;